export const NOTIFICATION_TIMER = 2000;
export const TIMER = 2000;
export const UNCONFIRMED_NEEDS_THRESHOLD = 200;
export const PRODUCT_UNPAYABLE_PERIOD = 14
export const NEST_GRACE_PERIOD = 15; // days
